import _ from 'lodash';
import jwt from 'jsonwebtoken'
import settings from "../config/settings";
import moment from 'moment'
import { useCallback, useState } from 'react';
import { IconButton, Box, Switch } from "@mui/material";

import { ReactComponent as RightNavIcon } from "../assets/icons/icon-angle-right-main.svg";
import { ReactComponent as LeftNavIcon } from "../assets/icons/icon-angle-left-main.svg";
import { ReactComponent as CancelButton } from "../assets/icons/icon-cancel.svg";

import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { Tooltip as Tooltip2 } from 'antd';
import { styled as CustomStyled } from '@mui/material/styles';
import { toast } from 'react-hot-toast';
import { CURRENCIES } from '../constants/filterType';

export const numberFormatter = new Intl.NumberFormat('en-IN')
export const compactNumberFormatter = new Intl.NumberFormat("en-US", {notation: "compact",maximumFractionDigits: 2,compactDisplay: "short"})
const currencyINRFormatter = new Intl.NumberFormat('en-IN', { style: "currency", currency: "INR" })
const currencyUSDFormatter = new Intl.NumberFormat('en-IN', { style: "currency", currency: "USD" })
export const compactcurrencyINRFormatter = new Intl.NumberFormat('en-IN', { style: "currency", currency: "INR" ,maximumFractionDigits: 2,notation: "compact",compactDisplay: "short"})
export const compactcurrencyUSDFormatter = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" ,maximumFractionDigits: 2,notation: "compact",compactDisplay: "short"})
const percentFormatter = new Intl.NumberFormat('en-IN',{style:'percent'})
const divMod = (n, m) => [Math.floor(n / m), n % m];
const createDurationFormatter = (locale, unitDisplay = 'short') => {
  const
    timeUnitFormatter = (locale, unit, unitDisplay) =>
      Intl.NumberFormat(locale, { style: 'unit', unit, unitDisplay }).format,
    fmtDays = timeUnitFormatter(locale, 'day', unitDisplay),
    fmtHours = timeUnitFormatter(locale, 'hour', unitDisplay),
    fmtMinutes = timeUnitFormatter(locale, 'minute', unitDisplay),
    fmtSeconds = timeUnitFormatter(locale, 'second', unitDisplay),
    fmtMilliseconds = timeUnitFormatter(locale, 'millisecond', unitDisplay),
    fmtList = new Intl.ListFormat(locale, { style: 'long', type: 'conjunction' });
  return (milliseconds) => {
    let days, hours, minutes, seconds;
    [days, milliseconds] = divMod(milliseconds, 864e5);
    [hours, milliseconds] = divMod(milliseconds, 36e5);
    [minutes, milliseconds] = divMod(milliseconds, 6e4);
    [seconds, milliseconds] = divMod(milliseconds, 1e3);
    return fmtList.format([
      days ? fmtDays(days) : null,
      hours ? fmtHours(hours) : null,
      minutes ? fmtMinutes(minutes) : null,
      seconds ? fmtSeconds(seconds) : null,
      //milliseconds ? fmtMilliseconds(milliseconds) : null
    ].filter(v => v !== null));
  }
};



export const CamelToNormalString = (str) => {
  let result = str.replace(/([A-Z])/g, " $1");
  let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult
}

export const decodedToken = (token) => {
  return jwt.verify(token, settings.AUTH_SECRET, (err, decoded) => {
    if (err) {
      console.log(err)
      return null
    }
    else {
      return decoded
    }
  })
}


export const UtcToLocalDate = (date) => {
  date = new Date(date)
  let userTimezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - userTimezoneOffset)
}

export const LocalToUTC = (date) => {
  date = new Date(date)
  let userTimezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() + userTimezoneOffset)
}

export const intlFormat = (num) => {
  //return new Intl.NumberFormat().format(Math.round(num * 10) / 10);
  return new Intl.NumberFormat('en-US', {notation:'compact',maximumFractionDigits: 2}).format(num)
}

export const FormatToShortNumber = (num) => {  
  return intlFormat(num);
}


export const CommaSeperator = num => {
  return new Intl.NumberFormat('en-IN').format(Number(num))
}


export const isValidEmail = email => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}


export const containsSpecialCharacter = data => {
  var specials = new RegExp(/[^A-Za-z 0-9_%()&*$#@?<>,]/, 'g');
  return specials.test(data);
}

export const isMobileView = () => {
  if (window.innerWidth < 500) {
    return true
  }
  else {
    return false
  }
}

export const chartLegendIcon = () => {
  return "path://M467.106909 581.073455l-107.636364-108.311273a55.645091 55.645091 0 1 0-78.94109 78.475636l148.154181 149.085091a55.458909 55.458909 0 0 0 40.680728 16.663273 55.389091 55.389091 0 0 0 39.982545-17.966546l278.039273-298.426181a55.645091 55.645091 0 1 0-81.454546-75.869091L467.130182 581.073455zM139.636364 0h744.727272a139.636364 139.636364 0 0 1 139.636364 139.636364v744.727272a139.636364 139.636364 0 0 1-139.636364 139.636364H139.636364a139.636364 139.636364 0 0 1-139.636364-139.636364V139.636364a139.636364 139.636364 0 0 1 139.636364-139.636364z"
}

export const LineChartLegendIcon = () => {
  return 'path://M0,3.18H28V4.82H0V3.18ZM17.5,3.5A3.5,3.5,0,1,1,10.5,3.5A3.5,3.5,0,1,1,17.5,3.5Z'
}

export const roundOfToZero = (numb, key, settings) => {
  if (settings?.conditionalFormat && settings?.conditionalFormat?.length && settings?.conditionalFormat[0]?.decimalPrecision) {
    let value = numb
    for (let format of settings?.conditionalFormat) {
      const { decimalPrecision, columnName } = format;
      if (columnName === key) {
        value = Number(value).toFixed(decimalPrecision)
        break;
      }
    }
    return value
  }
  else {
    return numb ? Number(Math.round(numb)) : 0
  }
}

export const isArrayEqual = (array1, array2) => {
  return _.isEqual(_.sortBy(array1), _.sortBy(array2))
}

export const StringTruncate = (str, n) => {
  if (str) {
    let val = (str.length > n) ? str.substr(0, n - 1) + '...' : str;
    return val;
  }
  return ''
};


export const convertPivotConfig = (pivot, result) => {

  let config = {
    xAxis: {
      id: "xAxis",
      list: [],
      label: 'X Axis'
    },
    value: {
      id: "value",
      list: [],
      label: 'Value'
    },
    lines: {
      id: "Lines",
      list: [],
      label: 'Lines'
    },
    group: {
      id: "group",
      list: [],
      label: 'Group'
    },
  }

  config.lines.list = pivot?.lines || []
  config.group.list = pivot?.group || [];

  if (!pivot?.x?.length && !pivot?.y?.length && result && result?.dimensions?.length) {

    let dimensions = result?.dimensions.map((dim) => {
      return { text: dim?.fieldName, type: 'dimensions', id: dim?.fieldId }
    });

    config.xAxis.list = dimensions;
    config.value.list = [{ id: "1", text: "measures", type: "measures" }]

    return config;
  }
  else {
    const xArr = pivot?.x;
    const yArr = pivot?.y;
    let measures = xArr.map((meas) => {
      return { text: meas, type: 'measures', id: Math.floor(Math.random() * 1000).toString() }
    });
    let dimensions = yArr.map((dim) => {
      return { text: dim, type: 'dimensions', id: Math.floor(Math.random() * 1000).toString() }
    });

    config.xAxis.list = measures;
    config.value.list = dimensions;

    return config;
  }
}

export const timeDimensionMapper = (query) => {
  if (Array.isArray(query)) {
    query?.map(qry => {
      if (qry?.timeDimensions) {
        let updatedTimeDimensions = []
        qry?.timeDimensions.map(obj => {
          let { dimension, dateRange, granularity, dateRangeArray, compareDateRange } = obj
          dateRangeArray = dateRangeArray?.length ? dateRangeArray : undefined
          compareDateRange = compareDateRange?.length ? compareDateRange : undefined
          updatedTimeDimensions.push({
            dimension, dateRange: dateRange || dateRangeArray,
            granularity: granularity === "null" ? null : granularity,
            compareDateRange,
          })
          return obj
        })
      }
      return qry
    })
  }
  else {
    let updatedTimeDimensions = []
    if (query.timeDimensions) {
      query.timeDimensions.map(obj => {
        let { dimension, dateRange, granularity, dateRangeArray, compareDateRange } = obj
        dateRangeArray = dateRangeArray?.length ? dateRangeArray : undefined
        compareDateRange = compareDateRange?.length ? compareDateRange : undefined

        updatedTimeDimensions.push({
          dimension, dateRange: dateRange || dateRangeArray,
          granularity: granularity === "null" ? null : granularity,
          compareDateRange,
        })
        return obj
      })

      query.timeDimensions = updatedTimeDimensions
    }
  }
  return query
}


export const abbreviateNumber = (number) => {
  const SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
  const tier = Math.log10(Math.abs(number)) / 3 | 0;
  if (tier === 0) return number;
  const suffix = SI_SYMBOL[tier];
  const scale = Math.pow(10, tier * 3);
  let scaled = number / scale;
  return scaled.toFixed(1) + suffix;
}

export const hexToRgb = hex => {
  return hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
    , (m, r, g, b) => '#' + r + r + g + g + b + b)
    .substring(1).match(/.{2}/g)
    .map(x => parseInt(x, 16))
}


export const formatOrderBy = (order, result) => {
  if (order && result) {
    const orderBy = Object.entries(order).map(([key, val]) => {
      return {
        id: Math.floor(Math.random() * 1000).toString(),
        content: {
          key: result?.dataSetId?.dataSetName + "." + key,
          order: val
        }
      }
    });
    return orderBy;
  }
  else if (!order?.length && result) {
    let order = [];
    if (result?.dimensions?.length) {
      for (let dim of result?.dimensions) {
        let obj = {
          id: dim?.fieldId,
          content: {
            key: dim?.fieldName,
            order: 'asc'
          }
        }
        order.push(obj)
      }
    }
    if (result?.measures?.length) {
      for (let meas of result?.measures) {
        let obj = {
          id: meas?.fieldId,
          content: {
            key: meas?.fieldName,
            order: 'desc'
          }
        }
        order.push(obj)
      }
    }
    return order;
  }
}

export const debouncingFn = (fn) => {
  return () => {
    const getData = setTimeout(() => {
      return fn()
    }, 500)

    return () => clearTimeout(getData)
  }
}

export const getReportFilterData = async (searchKey, params) => {
  const { filterObj, cubejsApi, queryObj, loaderFn, dataFn,onReport = false,filterList= [] } = params
  //console.log(filterObj)
  if (loaderFn) loaderFn(true)
  if (cubejsApi) {
    const query = {
      limit: 50,
      filters: []
    }
    let filterPresent = false
    if (filterObj.dataSetType === 'MEASURE') {
      query['measures'] = [filterObj.member]
      query['order'] = [[filterObj.member,'desc']]
    } else {
      query['dimensions'] = [filterObj.member]
      query['order'] = [[filterObj.member,'asc']]
    }    
    if (queryObj && queryObj.filters) {
      query['filters'] = [...queryObj.filters]
      filterPresent = queryObj.filters.find(obj => obj.member === filterObj.member && obj.operator === 'contains')
    }
    if(filterObj.extraFilters){
      let extraFilterObj = {
          [filterObj.conditionType]:[]       
      }
      for(let extFiltObj of filterObj.extraFilters){
        if(extFiltObj.member && extFiltObj.operator && (['set','notSet'].indexOf(extFiltObj.operator) > -1 || extFiltObj.values.length > 0)){
          extraFilterObj[filterObj.conditionType].push({
            member: extFiltObj.member,
            operator: extFiltObj.operator.split('#')[0],
            values: extFiltObj.values
          })
        }        
      }
      //console.log(extraFilterObj)
      if(extraFilterObj[filterObj.conditionType].length > 0){
        query.filters.push(extraFilterObj)
      }      
    }
    //console.log(query)
    if (searchKey) {
      if (filterPresent) {
        filterPresent.values = [...filterPresent.values, searchKey]
      } else {
        query.filters.push({
          member: filterObj.member,
          operator: 'contains',
          values: [searchKey]
        })
      }
    }

    if(filterObj.cascadedWith && onReport && filterList.length > 0) {
      let parentFilter = filterList.find(obj => obj.member === filterObj.cascadedWith && obj.onReport && obj.operator === 'equals')
      if(parentFilter){
        query.filters.push({
          member: parentFilter.member,
          operator: 'equals',
          values: parentFilter.values
        })
      }
    }

    try {
      const resultSet = await cubejsApi.load(query)
      let data = resultSet.rawData()
      //console.log(data)
      data = data.map(obj => {
        const value = obj[filterObj.member]
        return { value, label: value }
      })
      dataFn(data)
      loaderFn(false)
    } catch (e) {
      dataFn([])
      loaderFn(false)
      toast.error(e.message)
    }
  }

}

export const listReorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const formatTableData = (data, fields) => {
  return data.map(obj => {
    let record = {}
    fields.filter(fieldObj => !fieldObj.hidden && !fieldObj.concated).forEach(field => {
      record[field.member] = {}      
      record[field.member]['value'] = formatValue(field,obj,fields)  
      record[field.member]['rawValue'] =  obj[field.member] ?? 'NA'
      record[field.member]['width'] = field.width ?? 'auto'
      record[field.member]['align'] = field.align ?? 'left'
      record[field.member]['truncateCount'] = field.truncateCount
    })
    console.log(record)
    return record
  })
}

export const formatCurrency = (value,symbol) => {
  symbol = symbol ? symbol : 'USD'
  if(CURRENCIES.indexOf(symbol) < 0){
    symbol = 'INR'
  }
  let locale = symbol === 'INR' ? 'en-IN' :'en-US'
  let notation = 'compact'  
  if(symbol === 'INR'){
    locale = value > 99999 ? locale : 'en-US'
    notation = value > 99999 ? notation : 'standard'
  }
  //console.log(symbol)
  let formatter = new Intl.NumberFormat(locale, { style: "currency", currency: symbol ,minimumFractionDigits:0, maximumFractionDigits: 1, notation: notation,compactDisplay: "short"})
  return formatter.format(value)
}

export const formatValue = (field,dataObj,fields=null) => {
  const durationFormatter = createDurationFormatter('en-IN');
  let value = ""
  if(field.type != 'string'){
    switch(field.format){
      case 'number':
        value = numberFormatter.format(dataObj[field.member])
        break;
      case 'compactNumber':
        value = compactNumberFormatter.format(dataObj[field.member])
        break;
      case 'percent':
        value = percentFormatter.format(dataObj[field.member])
        break;
      case 'hour':
        let hrs = durationFormatter(dataObj[field.member] * 3.6e+6)
        value = hrs ? hrs : '0 hrs'
        break;
      case 'minute':
        let mins = durationFormatter(dataObj[field.member] * 60000)
        value = mins ? mins : '0 mins'
        break;
      case 'second':
        let secs = durationFormatter(dataObj[field.member] * 1000)
        value = secs ? secs : '0 secs'
        break;
      case 'INR':
        value = currencyINRFormatter.format(dataObj[field.member])
        break;
      case 'USD':
        value = currencyUSDFormatter.format(dataObj[field.member])
        break;
      case 'compactINR':
        value = formatCurrency(dataObj[field.member],'INR')
        break;
      case 'compactUSD':
        value = formatCurrency(dataObj[field.member],'USD')
        break;
      case '':
        value = dataObj[field.member]
        break;
      default:
        value = moment(dataObj[field.member]).format(field.format)
        break
    }
    //console.log(value)
  }else{
    value = dataObj[field.member]
  }

  if(field.truncate){
    value = dataObj[field.member] ? dataObj[field.member].toString().split(field.truncateWith).filter(Boolean): 'NA'
  }

  if(field.concatWith && field.concatWith.length > 0){
    let delimiter = field.delimiter
    let valArr = [value]
    for(let concatField of field.concatWith){
      if(fields.length > 0){
        let fieldObj = fields.find(obj => obj.member === concatField)
        if(fieldObj){
          let fieldValue = formatValue(fieldObj,dataObj,fields)
          valArr.push(fieldValue)
        }else{
          valArr.push(dataObj[concatField])
        }
      }else{
        valArr.push(dataObj[concatField])
      }      
    }
    value = valArr.filter(Boolean).join(delimiter)
  }

  return value
}

export const removeReference = (data) => {
  return JSON.parse(JSON.stringify(data))
}

export const SwitchButton = CustomStyled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

export const createMarkup = (text) => { return { __html: text }; }

export const updateQuery = (oldQuery, newQuery, fn) => {
  return fn({
    ...oldQuery,
    ...newQuery,
  })
}

export const getDateValByPeriod = (period) => {
  let currEndDate = moment().format("YYYY/MM/DD");
  let currentStartDate = moment().subtract(period, "days").format("YYYY/MM/DD");
  let prevEndDate = moment().subtract(period, "days").subtract(1, "days").format("YYYY/MM/DD");
  let prevStartDate = moment().subtract(period, "days").subtract(1, "days").subtract(period, "days").format("YYYY/MM/DD");

  return { currStart: currentStartDate, currEnd: currEndDate, prevStart: prevStartDate, prevEnd: prevEndDate }
}


export const CarouselNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <IconButton
      className={`er-slide-right-nav ` + className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <RightNavIcon />
    </IconButton>
  );
}

export const CarouselPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <IconButton
      className={`er-slide-left-nav ` + className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <LeftNavIcon />
    </IconButton>
  );
}

export const SwiperNextArrow = (props) => {
  
  const { className, style, onClick, refSwiper } = props;

  const handleNext = () => {
    if (!refSwiper?.current) return;
    refSwiper.current.swiper.slideNext();
  };

  return (
    <IconButton
      className={`er-slide-right-nav ` + className}
      style={{ ...style, display: "block" }}
      onClick={handleNext}
    >
      <RightNavIcon />
    </IconButton>
  );
}

export const SwiperPrevArrow = (props) => {
  
  const { className, style, onClick, refSwiper } = props;

  const handlePrev = () => {
    if (!refSwiper?.current) return;
    refSwiper.current.swiper.slidePrev();
  };

  return (
    <IconButton
      className={`er-slide-left-nav ` + className}
      style={{ ...style, display: "block" }}
      onClick={handlePrev}
    >
      <LeftNavIcon />
    </IconButton>
  );
}

export const generateCustomDateRange = (range) => {
  const dateRange = {
    startDate: '',
    endDate: ''
  }
  switch (range) {
    case 'Today':
      dateRange.startDate = moment().startOf('day').format('YYYY/MM/DD 00:00:00')
      dateRange.endDate = moment().endOf('day').format('YYYY/MM/DD 23:59:59')
      break
    case 'Yesterday':
      dateRange.startDate = moment().subtract(1, "days").startOf('day').format('YYYY/MM/DD 00:00:00')
      dateRange.endDate = moment().subtract(1, "days").endOf('day').format('YYYY/MM/DD 23:59:59')
      break
    case 'This Week':  //Mon-Sun of Curr Week
      dateRange.startDate = moment().startOf('isoWeek').startOf('day').format('YYYY/MM/DD 00:00:00')
      dateRange.endDate = moment().endOf('isoWeek').endOf('day').format('YYYY/MM/DD 23:59:59')
      break
    case 'Last Week':  //Mon-Sun Last Week
      dateRange.startDate = moment().subtract(1, 'weeks').startOf('isoWeek').startOf('day').format('YYYY/MM/DD 00:00:00');
      dateRange.endDate = moment().subtract(1, 'weeks').endOf('isoWeek').endOf('day').format('YYYY/MM/DD 23:59:59');
      break
    case 'This Month': //start to end of curr month
      dateRange.startDate = moment().startOf('month').startOf('day').format('YYYY/MM/DD 00:00:00')
      dateRange.endDate = moment().endOf('month').endOf('day').format('YYYY/MM/DD 23:59:59')
      break
    case 'Last Month': //start to end of last month
      dateRange.startDate = moment().subtract(1, 'month').startOf('month').startOf('day').format('YYYY/MM/DD 00:00:00');
      dateRange.endDate = moment().subtract(1, 'month').endOf('month').endOf('day').format('YYYY/MM/DD 23:59:59');
      break
    case 'This Quarter': //start to end of curr quarter
      dateRange.startDate = moment().startOf('quarter').startOf('day').format('YYYY/MM/DD 00:00:00')
      dateRange.endDate = moment().endOf('quarter').endOf('day').format('YYYY/MM/DD 23:59:59')
      break
    case 'Last Quarter': //start to end of last quarter
      dateRange.startDate = moment().subtract(1, 'quarter').startOf('quarter').startOf('day').format('YYYY/MM/DD 00:00:00');
      dateRange.endDate = moment().subtract(1, 'quarter').endOf('quarter').endOf('day').format('YYYY/MM/DD 23:59:59');
      break
    case 'This Year': //start to end of curr year
      dateRange.startDate = moment().startOf('year').startOf('day').format('YYYY/MM/DD 00:00:00')
      dateRange.endDate = moment().endOf('year').endOf('day').format('YYYY/MM/DD 23:59:59')
      break
    case 'Last Year': //start to end of last year
      dateRange.startDate = moment().subtract(1, 'year').startOf('year').startOf('day').format('YYYY/MM/DD 00:00:00');
      dateRange.endDate = moment().subtract(1, 'year').endOf('year').endOf('day').format('YYYY/MM/DD 23:59:59');
      break
    default:
      return dateRange;
  }
  return dateRange;
}

export const getDOMTextWidth = (text, font) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = font || getComputedStyle(document.body).font;
  return Math.round(context.measureText(text).width);
}

export const getDOMCanvasDimensions = (text, font, lineHeight, angle) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.rotate(angle * Math.PI / 360);
  context.font = font || getComputedStyle(document.body).font;
  let textWidth = Math.round(context.measureText(text).width);

  //document.
  let finalWidth = (textWidth + lineHeight) / (Math.cos(angle) + Math.sin(angle)) + (textWidth - lineHeight) / (Math.cos(angle) - Math.sin(angle));
  let finalHeight = (textWidth + lineHeight) / (Math.cos(angle) + Math.sin(angle)) - (textWidth - lineHeight) / (Math.cos(angle) - Math.sin(angle));

  return { hw: textWidth, rw: finalWidth / 2, rh: finalHeight / 2 }
}

export const getDOMTextDimensions = (text, font, lineHeight, rotationAngle) => {

  const fontOfEl = font || getComputedStyle(document.body).font;
  const dynamicContextEl = document.createElement('div');
  dynamicContextEl.style.cssText = "position:fixed;font:"
    + fontOfEl + ";line-height:"
    + lineHeight + "padding:0;margin:0;left:-9999px;top:-9999px;transform:rotate("
    + rotationAngle + "deg)";
  dynamicContextEl.innerHTML = text;
  document.body.appendChild(dynamicContextEl);

  return { w: dynamicContextEl.getBoundingClientRect().width, h: dynamicContextEl.getBoundingClientRect().height }
}


export const getMaxOfArray = (arr) => {
  return arr.length && arr.reduce(
    function (a, b) {
      return a.length > b.length ? a : b;
    }
  );
}

export const handleDataFormat = (settings, num) => {
  let formatted = num
  if (formatted) {
    if (settings?.dataFormat) {
      if (settings?.dataFormat?.format === 'percentage') {
        formatted = formatted + '%'
      }
      else if (settings?.dataFormat?.timeFormat) {
        formatted = formatNumberTimeField(formatted, settings?.dataFormat?.timeFormat)
      }
      else if (settings?.dataFormat?.currencyFormat) {
        formatted = `${settings?.dataFormat?.currencyFormat} ${formatted}`
      }
      else {
        formatted = CommaSeperator(formatted)
      }
    }
    else {
      formatted = CommaSeperator(formatted)
    }
  }
  return formatted
}

export const formatNumberTimeField = (value, type, compact=false) => {
  let
    //strHr, 
    hours, minutes, seconds;

  if (type === 'seconds') {
    const sec = parseInt(value, 10);
    hours = Math.floor(sec / 3600);
    minutes = Math.floor((sec - (hours * 3600)) / 60);
    seconds = sec - (hours * 3600) - (minutes * 60);
    // if (hours < 10) {
    //   if (hours) {
    //     strHr = "0" + hours;
    //   }
    //   hours = "0" + hours;
    // }
    // else {
    //   strHr = hours
    // }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }
  else if (type === 'minutes') {
    const min = parseFloat(value, 10);
    hours = Math.floor(min / 60);
    minutes = Math.floor((min - ((hours * 3600)) / 60));
    seconds = Math.floor((min * 60) - (hours * 3600) - (minutes * 60));

    // if (hours < 10) {
    //   if (hours) {
    //     strHr = "0" + hours;
    //   }
    //   hours = "0" + hours;
    // }
    // else {
    //   strHr = hours
    // }

    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }
  else if (type === 'hours') {
    const hr = parseFloat(value, 10);
    hours = Math.floor(hr);
    minutes = (Math.abs(hr) - hours) * 60
    seconds = (Math.abs(minutes) - Math.floor(minutes)) * 60

    // if (hours < 10) {
    //   if (hours) {
    //     strHr = "0" + hours;
    //   }
    //   hours = "0" + hours;
    // }
    // else {
    //   strHr = hours
    // }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }

  if (Number(hours) < 1) {
    let formatted = Math.floor(Number(minutes)) + 'Min ' + Math.floor(Number(seconds)) + 'Sec ';
    return formatted;
  }
  else {
    let formatted;
    if(compact) {
      hours = FormatToShortNumber(hours);
      formatted = hours + 'Hr ' + Math.floor(Number(minutes)) + 'Min '
    } else {
      formatted = Math.floor(Number(hours)) + 'Hr ' + Math.floor(Number(minutes)) + 'Min '
    }
    return formatted;
  }

}


export const CustomTooltip = CustomStyled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#CFE0FF',
    fontSize: 16,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#CFE0FF',
    color: '#202124',
    padding: '6px',
    fontSize: '10px',
    borderRadius: '4px',
    // marginTop: '4px',
  },
}));

export const CustomTooltip2 = ({ ...props }) => {
  return <Tooltip2 {...props} mouseLeaveDelay={0} />
}

export const applyFilterOnLinkedReports = async (report, measureListByDataset, fetchMeasureListByDatasetId) => {
  let { linkedReports, reportFilters } = report;
  reportFilters = reportFilters?.filter((filter) => filter?.listType);
  if (!linkedReports?.length || !reportFilters.length) return report;
  report.linkedReports = await Promise.all(linkedReports.map(async (linkedReport) => {
    let { reportId } = linkedReport;
    const datasetId = typeof reportId?.dataSetId === 'object' ? reportId?.dataSetId?._id : reportId?.dataSetId;
    let datasetMesureList = measureListByDataset[datasetId] || await fetchMeasureListByDatasetId(datasetId);
    await reportFilters.forEach((filter) => {
      let isMeasureAvailable = datasetMesureList.find((measure) => measure.name === filter.member.split('.')[1]);
      if (isMeasureAvailable) {
        const filterIndex = reportId.reportFilters.findIndex((reportFilter) => reportFilter.member.split('.')[1] === filter.member.split('.')[1]);
        if (filterIndex > -1) {
          const datasetName = (reportId?.measures?.[0]?.fieldName || reportId?.dimensions?.[0]?.fieldName)?.split('.')[0];
          reportId.reportFilters[filterIndex] = {
            ...reportId.reportFilters[filterIndex],
            ...filter,
            member: `${datasetName}.${filter.member.split('.')[1]}`,
          }
        } else {
          const datasetName = (reportId?.measures?.[0]?.fieldName || reportId?.dimensions?.[0]?.fieldName)?.split('.')[0];
          reportId.reportFilters = [...reportId.reportFilters, {
            ...filter,
            member: `${datasetName}.${filter.member.split('.')[1]}`,
          }]
        }
      }
    });
    return { ...linkedReport, reportId }
  }));
  return report;
};

export const ApplyBottomToastr = ({ message }) => {

  const [toastrStatus, setToastrStatus] = useState(true);

  return (
    <Box className={`reports-notice style2` + (toastrStatus ? ` show` : ` hide`)}>
      <Box className="reports-notice-container">
        <Box className="reports-notice-content">{message}</Box>
        <CancelButton className="reports-notice-endicon" onClick={() => setToastrStatus(false)} />
      </Box>
    </Box>
  )
}

export const isMobileDevice = () => {
  if (!window.matchMedia) return;
  return window.matchMedia("(pointer:coarse)").matches;
}

export const mapLinkedResponseData = (reportData) => {
  let clonedReportData = _.cloneDeep(reportData)
  return clonedReportData?.linkedReports?.map(reportObj => {
    if(reportObj){
      const pivotConfig = convertPivotConfig(reportObj?.reportId?.pivotConfig, reportObj?.reportId);
      const orderBy = formatOrderBy(reportObj?.reportId?.orderBy, reportObj?.reportId);

      reportObj.reportName = reportObj?.reportId?.reportName
      if(reportObj.reportId){
        reportObj.reportId.pivotConfig = pivotConfig;
        reportObj.reportId.orderBy = orderBy;
      }        
    }
    return reportObj
  })
}

export const CustomSwitch = CustomStyled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#f45e29',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));